import leadgen from './lead-gen';
import translation from './chatterton/translation';
import transcription from './chatterton/transcription';

export const viewReducers = {
  leadgen,
  translation,
  transcription,
};
